import React, { useEffect } from "react";
import LoyaltyLevel from "../../components/Loyalty/LotaltyLevel";
import { connect } from "react-redux";
import { syncLoyalty, updateLoyaltySettings } from "../../actions/loyalty";
import LoyaltyAmountSetting from "../../components/Loyalty/forms/LoyaltyAmountSetting";

const Loyalty = ({ syncLoyalty, loyalty, updateLoyaltySettings, auth }) => {
	useEffect(() => {
		if (auth.adminDB) {
			syncLoyalty();
		}
	}, [syncLoyalty, auth]);

	const onSubmit = (level, values) => {
		if (level !== "amount" && level !== "cap") {
			values = Object.entries(values).reduce((acc, [key, val]) => {
				return { ...acc, [key]: Number(val) };
			}, {});
		} else {
			values = Number(values);
		}
		updateLoyaltySettings({ level, values });
	};

	return (
		<div>
			<div style={{ display: "flex", justifyContent: "center", gap: "1em" }}>
				<LoyaltyAmountSetting
					defaultValues={{ amount: loyalty?.amount }}
					label="Min para obtener un punto"
					name="amount"
					onSubmit={({ amount }) => {
						onSubmit("amount", amount);
					}}
				/>
				<LoyaltyAmountSetting
					defaultValues={{ cap: loyalty?.cap }}
					label="Puntos Max en una compra"
					name="cap"
					onSubmit={({ cap }) => {
						onSubmit("cap", cap);
					}}
				/>
			</div>
			<div style={{ display: "flex" }}>
				<LoyaltyLevel
					defaultValues={loyalty?.silver}
					label="Nivel Plata"
					onSubmit={(values) => {
						onSubmit("silver", values);
					}}
				/>
				<LoyaltyLevel
					defaultValues={loyalty?.gold}
					label="Nivel Oro"
					onSubmit={(values) => {
						onSubmit("gold", values);
					}}
				/>
				<LoyaltyLevel
					defaultValues={loyalty?.platinum}
					label="Nivel Platino"
					onSubmit={(values) => {
						onSubmit("platinum", values);
					}}
				/>
			</div>
		</div>
	);
};

const mapPropsToState = ({ loyalty, auth }) => {
	return { loyalty: loyalty.loyaltySettings, auth: auth.databasesRef };
};

export default connect(mapPropsToState, { updateLoyaltySettings, syncLoyalty })(Loyalty);
